<template>
    <div>
        <div>
            <b-nav tabs>
                <b-nav-item router-link to="/overview-sale-list">
                    <icon name="file-alt"></icon>
                    ภาพรวมการขาย
                </b-nav-item>&nbsp
                <b-nav-item router-link to="/transport-fee-report">
                    <icon name="file-alt"></icon>
                    รายงานค่าขนส่งของเซลล์
                </b-nav-item>&nbsp
                <b-nav-item router-link to="/tax-driver-report">
                    <icon name="file-alt"></icon>
                    รายงานภาษี 1%
                </b-nav-item>&nbsp
            </b-nav>
        </div>
        <div class="container-fluid" style="background-color: white">
            <router-view />
        </div>
    </div>
</template>

<script>
    export default {
        name: "overview-sale-layout"
    }
</script>

<style scoped>

</style>
